import React, { useState } from "react";
import { adminAxios } from "../api";
import { toast } from "sonner";
import { KeyRound, Loader2, Eye, EyeOff } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const ChangePassword = () => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (next !== confirm) { toast.error("New passwords do not match"); return; }
    if (next === current) { toast.error("New password must be different from the current password"); return; }
    setSaving(true);
    try {
      await adminAxios.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password changed successfully");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not change password");
    } finally { setSaving(false); }
  };

  return (
    <div className="max-w-lg">
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Change Password</h1>
      <p className="text-slate-500 mb-6">Secure your admin account before sharing the live site.</p>

      <form onSubmit={submit} data-testid="change-password-form" className="bg-white rounded-xl border border-slate-200 p-6 space-y-4">
        <div>
          <Label className="text-sm text-slate-700">Current password</Label>
          <Input data-testid="cp-current" type={show ? "text" : "password"} value={current} onChange={(e) => setCurrent(e.target.value)} required className="mt-1" placeholder="Enter current password" />
        </div>
        <div>
          <Label className="text-sm text-slate-700">New password</Label>
          <Input data-testid="cp-new" type={show ? "text" : "password"} value={next} onChange={(e) => setNext(e.target.value)} required className="mt-1" placeholder="At least 8 characters" />
        </div>
        <div>
          <Label className="text-sm text-slate-700">Confirm new password</Label>
          <Input data-testid="cp-confirm" type={show ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="mt-1" placeholder="Re-enter new password" />
        </div>
        <button type="button" onClick={() => setShow((s) => !s)} className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700">
          {show ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />} {show ? "Hide" : "Show"} passwords
        </button>
        <Button data-testid="cp-submit" type="submit" disabled={saving} className="w-full bg-slate-900 hover:bg-slate-800">
          {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />} Update Password
        </Button>
      </form>
    </div>
  );
};

export default ChangePassword;
